module.exports = __webpack_public_path__ + "img/honourable.41652ca1.png";